import Axios from "axios";

const baseURL = process.env.BARRAMUNDI;
const baseURLci = process.env.CI_APPS;
export default {
    getWebform(params) {
        return Axios.get(`${process.env.BARRAMUNDI}actor/webform`, {
            params
        }).then(response => {
            if (response && response.data && response.data.response) {
                return response.data.response;
            } else {
                return null;
            }
        });
    },
    getWebformDetail(webformId, isEncodedId = false) {
        return Axios.get(
            `${process.env.BARRAMUNDI}actor/webform/${webformId}`,
            { params: { encoded: isEncodedId } }
        ).then(response => {
            if (
                response &&
                response.data &&
                response.data.response &&
                response.data.response.code == 200
            ) {
                return response.data.response.resource;
            } else {
                return null;
            }
        });
    },
    /**
     * Create new webform
     * @param {Object} params
     *   "client_id": "{{clientId}}",
     *    "template_id": "{{templateId}}",
     *    "title": "Testing Webform",
     *    "date": 1687242632,
     *    "content": "{'value': 'color'}",
     *    "answers": "{'value': 'white'}"
     * @returns
     */
    async saveWebform(params) {
        const res = await Axios.post(`${baseURL}actor/webform`, params);
        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.resource
        ) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    /**
     * Update existing webform
     * @param {String} webformId
     * @param {Object} params
     * @returns
     */
    async updateWebform(webformId, params) {
        const res = await Axios.put(
            `${baseURL}actor/webform/${webformId}`,
            params
        );
        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.resource
        ) {
            return res.data.response.resource;
        } else {
            return null;
        }
    },
    /**
     * Delete existing webform
     * @param {String} webformId
     * @returns
     */
    async deleteWebform(webformId) {
        const res = await Axios.delete(`${baseURL}actor/webform/${webformId}`);
        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.code == 200
        ) {
            return res.data.response;
        } else {
            return null;
        }
    },
    /**
     * Get content for SMS and Email to send to client
     * @param {String} webformId
     * @returns
     */
    async getCommunicationContent(webformId, params) {
        const res = await Axios.post(
            `${baseURL}actor/webform/${webformId}/renderSendContent`,
            params
        );
        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.code == 200
        ) {
            return res.data.response;
        } else {
            return null;
        }
    },
    async sendWebform(webformId, params) {
        const res = await Axios.post(
            `${baseURL}actor/webform/${webformId}/send`,
            params
        );
        if (
            res &&
            res.data &&
            res.data.response &&
            res.data.response.code == 200
        ) {
            return res.data.response;
        } else {
            return null;
        }
    }
};
